import { render } from "./tournament-slots.template.html?vue&type=template&id=076827bf&scoped=true"
import script from "./TournamentSlots.vue?vue&type=script&lang=ts"
export * from "./TournamentSlots.vue?vue&type=script&lang=ts"

import "./TournamentSlots.vue?vue&type=style&index=0&id=076827bf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-076827bf"

export default script